export const LOGIN_PATH = '/user/login';
